import { compose, pure } from "recompose";
import withStyles from "./styles";

const enhance = compose(
  pure,
  withStyles
);

export default enhance;
